import AppDashboard from "@kinetics254/cassandra-base/app/layout/AppDashboard";
import Auth from "@kinetics254/cassandra-base/modules/auth/middleware/Auth";
import EditProfile from "./views/EditProfile.vue";

export default [
  {
    path: "/profile",
    component: AppDashboard,
    children: [
      {
        path: "",
        name: "Edit Profile",
        components: {
          view: EditProfile,
        },
        meta: {
          middleware: Auth,
          breadcrumb: [{ text: "profile", disabled: false, href: "/profile" }],
        },
      },
    ],
  },
];
